export const sidebar = {
  header: {
    menu: "MENU",
  },
  items: {
    home: "Start",
    reservations: "Rezerwacje",
    calendar: "Kalendarz",
    hourlyCalendar: "Na godziny",
    calls: "Połączenia",
    aiReception: "Recepcja AI",
    availabilityRates: "Dostępność i stawki",
    checkins: "Check-iny",
    channels: "Kanały rezerwacji",
    inbox: "Skrzynka odbiorcza",
    settings: "Ustawienia",
    experiences: "Atrakcje",
    scheduleCall: "Umów rozmowę",
    support: "Pomoc",
    novedades: "Nowości",
    messages: "Wiadomości",
    badgeNew: "Nowe",
    invoicing: "Fakturowanie",
    customers: "Klienci",
    clientsDirectory: "Klienci",
    fiscalCustomers: "Klienci do faktur",
    invoices: "Faktury",
    housekeeping: "Sprzątanie",
    analytics: "Analityka",
  },
  alt: {
    logo: "Logo",
  },
};
